var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class SharpPnuh {
    constructor(socket, log) {
        this.socket = socket;
        this.apiState = 'username';
        this.firmwareVersion = 'SW 1.00';
        this.power = false;
        this.serialNumber = '12345678';
        this.videoSelection = '1';
        this.volume = 20;
        this.volumeMute = false;
        this.timeouts = new Timeouts();
        this.apiAsyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /SWVN1/i,
                callback: (match) => {
                    this.socket.send(this.firmwareVersion);
                },
            },
            {
                name: 'serialNumber',
                regExp: /SRNO\s*\?+/i,
                callback: (match) => {
                    this.socket.send(this.serialNumber);
                },
            },
            {
                name: 'powerQuery',
                regExp: /POWR\s*\?+/i,
                callback: (match) => {
                    this.socket.send(this.power ? '1' : '0');
                },
            },
            {
                name: 'powerSet',
                regExp: /POWR\s*(\d+)/i,
                callback: (match) => {
                    if (match[1]) {
                        this.power = parseInt(match[1], 10) === 1 ? true : false;
                        this.socket.send('OK');
                    }
                    else {
                        this.socket.send('ERR');
                    }
                },
            },
            {
                name: 'videoQuery',
                regExp: /INPS\s*\?+/i,
                callback: (match) => {
                    this.socket.send(this.videoSelection);
                },
            },
            {
                name: 'videoSet',
                regExp: /INPS\s*(\d+)/i,
                callback: (match) => {
                    this.videoSelection = match[1] ? match[1] : '1';
                    this.socket.send(`OK`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /VOLM\s*\?+/i,
                callback: (match) => {
                    this.socket.send(this.volume.toString());
                },
            },
            {
                name: 'volumeSet',
                regExp: /VOLM\s*(\d+)/i,
                callback: (match) => {
                    if (match[1]) {
                        this.volume = parseInt(match[1], 10);
                        this.socket.send('OK');
                    }
                    else {
                        this.socket.send('ERR');
                    }
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /MUTE\s*\?+/i,
                callback: (match) => {
                    this.socket.send(`${this.volumeMute ? 1 : 0}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /MUTE\s*(\d+)/i,
                callback: (match) => {
                    if (match[1]) {
                        this.volumeMute = match[1] === '1' ? true : false;
                        this.socket.send('OK');
                    }
                    else {
                        this.socket.send('ERR');
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`ERR`);
                },
            },
        ];
        this.authAsyncHandlers = [
            {
                regExp: /.+/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.apiState === 'username') {
                        this.apiState = 'password';
                        this.socket.sendRaw(`Password: `);
                        // Delay allows emulator to ignore the empty password and respond to allow the
                        // driver to continue connecting.
                        yield this.timeouts.delay(500);
                        this.apiState = 'authenticated';
                        this.socket.send(`OK`);
                        this.asyncHandlers = this.apiAsyncHandlers;
                    }
                }),
            },
        ];
        this.asyncHandlers = this.authAsyncHandlers;
        this.socket.onBeforeConnect(this.onBeforeConnect.bind(this));
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.apiState = 'username';
            this.asyncHandlers = this.authAsyncHandlers;
            yield this.timeouts.delay(1000);
            this.socket.sendRaw(`Login: `);
        });
    }
    wakeOnLan() {
        this.power = true;
        this.socket.setCanConnect(!(this.socket.getPort() === 10008 || this.socket.getPort() === 8888) || this.power);
    }
    onBeforeConnect(host, port, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.setCanConnect(!(port === 10008 || port === 8888) || this.power);
        });
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '1';
    }
}
SharpPnuh.emulatorType = 'socketEmulator';
SharpPnuh.key = '-LbTg4Fgml39SETg_xZM';
